import { createActionTypes } from 'utils/action/actionTypes';

export const RATING_REVIEW = createActionTypes('RATING_REVIEW');
export const DOWNLOAD_RATING_REVIEW = createActionTypes('DOWNLOAD_RATING_REVIEW');
export const RATING_REVIEW_SUMMARY = createActionTypes('RATING_REVIEW_SUMMARY');
export const DOWNLOAD_RATING_REVIEW_SUMMARY = createActionTypes('DOWNLOAD_RATING_REVIEW_SUMMARY');
